import store from '../../store'

export default function auth({next, router}) {
  const authToken = store.dispatch('loadAuthToken')
  if (!authToken) return router.push({name: 'public-auth-login'})
  if (!authToken) return router.push({name: 'general-dashboard'})
  return next()
}



// WEBPACK FOOTER //
// ./src/router/middlewares/auth.js